import { observable } from 'mobx';

import { SerializedData, Store } from 'bernie-core';

import { NoListingsType } from 'types/search/error-messages';
import { FlightsActionableErrorMessaging } from 'types/shared';

export class ErrorStore extends Store {
  @observable public clientFetchFailure: boolean;
  @observable public noListingMessaging: NoListingsType;
  @observable public failedRequestMessaging: FlightsActionableErrorMessaging;
  @observable public noApiResponse: boolean;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}

ErrorStore.DEFAULTS = {
  clientFetchFailure: false,
  noListingMessaging: null,
  failedRequestMessaging: null,
  noApiResponse: true
};
